'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const zones = ['All Zones', 'Maharashtra', 'Gujarat', 'Rajasthan', 'Delhi NCR', 'Karnataka', 'Tamil Nadu'];
const months = ['April 2026', 'March 2026', 'February 2026', 'May 2026'];
const statuses = ['All Status', 'Submitted', 'Pending', 'Draft', 'Verified'];
const types = ['All Types', 'Projects', 'Activities', 'Habits'];

export default function DashboardHeader() {
  const [zone, setZone] = useState('All Zones');
  const [month, setMonth] = useState('April 2026');
  const [status, setStatus] = useState('All Status');
  const [type, setType] = useState('All Types');

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-extrabold text-foreground leading-tight">
            Campaign Monitor
          </h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Respecting Mother Nature — Real-time centre progress across all zones
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[var(--success-bg)] text-[var(--success)] text-xs font-semibold">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--success)] animate-pulse" />
            Live — 04 May 2026, 11:27
          </span>
          <button className="btn-secondary text-xs px-3 py-2">
            <Icon name="ArrowDownTrayIcon" size={15} variant="outline" />
            Export
          </button>
        </div>
      </div>
      {/* Filter Bar */}
      <div className="flex flex-wrap items-center gap-2 p-3 bg-card rounded-2xl border border-border shadow-card">
        <Icon name="FunnelIcon" size={16} variant="outline" className="text-muted-foreground flex-shrink-0" />
        <span className="text-xs font-semibold text-muted-foreground mr-1">Filters:</span>

        {[
          { label: 'Zone', value: zone, options: zones, setter: setZone },
          { label: 'Month', value: month, options: months, setter: setMonth },
          { label: 'Status', value: status, options: statuses, setter: setStatus },
          { label: 'Type', value: type, options: types, setter: setType },
        ]?.map((filter) => (
          <div key={`filter-${filter?.label}`} className="relative">
            <select
              value={filter?.value}
              onChange={(e) => filter?.setter(e?.target?.value)}
              className="appearance-none pl-3 pr-7 py-1.5 rounded-lg border border-border bg-background text-xs font-medium text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 cursor-pointer hover:border-primary/50 transition-colors"
              aria-label={filter?.label}
            >
              {filter?.options?.map((opt) => (
                <option key={`opt-${filter?.label}-${opt}`} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <Icon
              name="ChevronDownIcon"
              size={12}
              variant="outline"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>
        ))}

        <button
          onClick={() => {
            setZone('All Zones');
            setMonth('April 2026');
            setStatus('All Status');
            setType('All Types');
          }}
          className="ml-auto text-xs font-medium text-muted-foreground hover:text-primary transition-colors"
        >
          Clear filters
        </button>
      </div>
    </div>
  );
}